import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthState } from '../auth/AuthContext';
import { isAdmin, isSignedIn, isTemporaryUser } from '../auth/roles';
import { Paths } from './paths';

/** Any signed-in user. Mirrors the legacy PrivateRoute. */
export function PrivateRoute() {
    const auth = useAuthState();
    const location = useLocation();
    return isSignedIn(auth) ? (
        <Outlet />
    ) : (
        <Navigate to={Paths.login} replace state={{ from: location }} />
    );
}

/** Administrators only. Legacy sends non-admins to the AD login. */
export function AdminRoute() {
    const auth = useAuthState();
    return isAdmin(auth) ? <Outlet /> : <Navigate to={Paths.adLogin} replace />;
}

/** Mid-2FA temporary users only. Legacy sends everyone else home. */
export function TemporaryRoute() {
    const auth = useAuthState();
    return isTemporaryUser(auth) ? <Outlet /> : <Navigate to={Paths.home} replace />;
}
